import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypePrintablesLibraryBookSkeleton } from './TypePrintablesLibraryBook'

export interface TypePrintablesLibrarySetFields {
  bookTitle: EntryFieldTypes.Symbol
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading' | 'Writing'>
  product?: EntryFieldTypes.Symbol<'mathseeds' | 'mathseeds-prime'>
  category?: EntryFieldTypes.Symbol<'General' | 'Reader'>
  gradePosition: EntryFieldTypes.Integer
  subject: EntryFieldTypes.Symbol
  series?: EntryFieldTypes.Symbol
  keywords: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  description: EntryFieldTypes.RichText
  books: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypePrintablesLibraryBookSkeleton>>
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<
      | 'All'
      | 'Australia'
      | 'Canada'
      | 'China'
      | 'India'
      | 'Korea'
      | 'New Zealand'
      | 'South Africa'
      | 'Thailand'
      | 'United Kingdom'
      | 'United States'
    >
  >
  programUrl?: EntryFieldTypes.Symbol
}

export type TypePrintablesLibrarySetSkeleton = EntrySkeletonType<TypePrintablesLibrarySetFields, 'printablesLibrarySet'>
export type TypePrintablesLibrarySet<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypePrintablesLibrarySetSkeleton,
  Modifiers,
  Locales
>

export function isTypePrintablesLibrarySet<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypePrintablesLibrarySet<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'printablesLibrarySet'
}

export type TypePrintablesLibrarySetWithoutLinkResolutionResponse = TypePrintablesLibrarySet<'WITHOUT_LINK_RESOLUTION'>
export type TypePrintablesLibrarySetWithoutUnresolvableLinksResponse =
  TypePrintablesLibrarySet<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypePrintablesLibrarySetWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypePrintablesLibrarySet<'WITH_ALL_LOCALES', Locales>
export type TypePrintablesLibrarySetWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesLibrarySet<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypePrintablesLibrarySetWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesLibrarySet<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
